import React from "react"

import * as styles from "../../styles/components/footer.module.scss"

import social1 from "../../images/social1.png"
import social2 from "../../images/social2.png"
import social3 from "../../images/social3.png"
import blueSapphire from "../../images/blueSapphire.png"
import payment1 from "../../images/payment1.png"
import payment2 from "../../images/payment2.png"
import partner1 from "../../images/partnerImage1.png"
import partner2 from "../../images/partnerImage2.png"
import partner3 from "../../images/partnerImage3.png"
import partner4 from "../../images/partnerImage4.png"
import nugoIcon from "../../images/nugo_icon.png"
import newMacauTiny from "../../images/icon-sm.png"

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__wrapper}>
        <div className={styles.footer__header}>
          <div className={styles.footer__social}>
            <h5>Connect</h5>
            <a href="mailto:info@newmacaucasino.com" target="_top blank">
              <img src={social1} alt="email" />
            </a>
            <a href="https://www.facebook.com/newmacaucasino" target="blank">
              <img src={social2} alt="facebook" />
            </a>
            <a href="https://www.instagram.com/newmacaucasino/" target="blank">
              <img src={social3} alt="instagram" />
            </a>
          </div>
          <span className={styles.footer__divider} />
          <div className={styles.footer__message}>
            <p>
              Gambling should always be regarded as a leisure activity and never
              an addiction. Please play responsibly.
            </p>
          </div>
        </div>
      </div>
      <div
        className={[styles.footer__wrapper, styles.footer__wrapper2].join(" ")}
      >
        <div className={styles.footer__main}>
          <div
            className={[styles.footer__item, styles.footer__item1].join(" ")}
          >
            <h5>Managed By:</h5>
            <div className={styles.footer__imageContainer}>
              <a href="http://www.bluesapphiregaming.com/" target="blank">
                <img
                  className={styles.blueSapphireLogo}
                  src={blueSapphire}
                  alt="blue sapphire"
                />
              </a>
            </div>
          </div>

          <span className={styles.footer__divider2} />

          <div
            className={[styles.footer__item, styles.footer__item2].join(" ")}
          >
            <h5>Payment Providers:</h5>
            <div className={styles.footer__imageContainer}>
              <img src={payment1} alt="mastercard" />
              <img src={payment2} alt="visa" />
            </div>
          </div>

          <span className={styles.footer__divider2} />

          <div
            className={[styles.footer__item, styles.footer__item3].join(" ")}
          >
            <h5>Service Providers:</h5>
            <div className={styles.footer__imageContainer}>
              <img src={partner1} alt="partners" />
              <img src={partner2} alt="partners" />
              <img src={partner3} alt="partners" />
              <img src={partner4} alt="partners" />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer__copyrightContainer}>
        <div className={styles.footer__copyright}>
          <div
            className={[
              styles.footer__copyrightItem,
              styles.footer__copyrightItem1,
            ].join(" ")}
          >
            <a href="https://www.newmacaucasino.com/">
              <img src={newMacauTiny} alt="new macau logo" />
            </a>
          </div>
          <div
            className={[
              styles.footer__copyrightItem,
              styles.footer__copyrightItem2,
            ].join(" ")}
          >
            <p>
              Copyright © {new Date().getFullYear()} New Macau Casino All Rights
              Reserved.
            </p>
          </div>
          <div
            className={[
              styles.footer__copyrightItem,
              styles.footer__copyrightItem3,
            ].join(" ")}
          >
            <a href="https://www.nugo.xyz" target="blank">
              <img src={nugoIcon} alt="nugo" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
